import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { BlogAuthorDto } from '@/components/BlogPage/types';
import { buildPersonJsonLd } from '@/lib/person-schema';
interface Props {
  author: BlogAuthorDto;
}
const PersonJsonLd: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    author
  } = t0;
  let t1;
  if ($[0] !== author) {
    t1 = JSON.stringify(buildPersonJsonLd(author));
    $[0] = author;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default PersonJsonLd;